<template>
    <div class="user-box">
        <div class="user-header">
           <div class="user-icon">
               <img src="../../assets/images/user-icon.png"/>
           </div>
           <div class="user-info" v-if="userInfo === null">
               <router-link to="/login">登录</router-link>
               <router-link to="/reg">注册</router-link>
           </div>
           <div class="user-info" v-else>
               <div class="name">{{userInfo.nickname}}</div>
               <div class="user-id">账户ID：{{userInfo.id}}</div>
           </div>
        </div>
     <van-cell title="全部订单" is-link to="/order" />
       <van-cell title="结算中心" is-link to="/commission" />
       <van-cell title="我的邀请" is-link to="/invite" />
       <van-cell title="邀请记录" is-link to="/inviteRecord" />
       <van-cell title="新手引导" is-link to="/help" />
       <van-cell title="设置" is-link to="/set" />

    </div>
</template>

<script>
export default {
     data() {
      return {
        userInfo:null
      }
    },
    created(){
        this.Post({
        }, "/main/userinfo", res => {
            if (res.states == 1) {
                this.userInfo = res.data;
                window.localStorage.setItem('userInfo',JSON.stringify(res.data))
                this.$store.dispatch("setUser", res.data);
            }else if(res.states == 400) {
                this.userInfo = null
                this.$store.dispatch("setUser", {});
            }else{
                this.Toast.fail(res.msg);
            }
        });
    },
}
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
   .user-box{
      .user-header{
        background: #fe3738;
          display: flex;
        align-items: center;
          padding: 20px;
          .user-icon{
              img{
                  width: 60px;
                  height: 60px;
              }
          }
          .user-info{
              flex: 1;
              padding-left: 14px;
            font-size: 16px;
            a{
              color: #ffffff;
              padding-right: 14px;
            }
              .name{
                color: #ffffff;
                 padding-bottom: 4px;
              }
              .user-id{
                color: #ffffff;
                font-size: 10px;
              }
          }
      }
   }
</style>



// WEBPACK FOOTER //
// src/pages/mine/user.vue